import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../Master/database/database.service';
import { Database } from '../Master/database/database';
import { ToastrService } from 'ngx-toastr';
import { UseraddService } from '../Master/useradd/useradd.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { navmenuservices } from '../nav-menu/nav-menu.services';
import { LocalService } from '../local.service';
declare var $: any;

@Component({
  selector: 'app-databasemgmt',
  templateUrl: './databasemgmt.component.html',
  styleUrls: ['./databasemgmt.component.css'],
  providers: [navmenuservices]
})
export class DatabasemgmtComponent implements OnInit {
  sendMenuId: number = 3;
  sendPageName: string = 'Database Management';
  _actionRights: any;
  database: string;
  public list;
  _usermappedDatabase = [];
  //public userid = +localStorage.getItem('userid');
  public userid = +this.localService.getJsonValue('userid');
  p: number = 1; searchTextforDatabase: string; itemsPerPage: number = 3;
  dataBases: any = [];

  constructor(private databaseService: DatabaseService,
    private toastr: ToastrService, private UseraddService: UseraddService,
    private route: ActivatedRoute,
    private router: Router, private navmenuservice: navmenuservices,
    private _sanitizer: DomSanitizer, private useraddService: UseraddService,
    private localService: LocalService) { 

    }

  ngOnInit() {
    this.checkIsMenuMapped();
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
   // this.getAllDataBases();
    this.getActionRightsList(); 
   this.getUserMappedDatabase();
    this.LoadActionRights();
    
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedDatabaseManagement");
    let data = arrays.find(ob => ob['name'] === 'Database Management');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedDatabaseManagement","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedDatabaseManagement",null);
      this.router.navigate(["home"]);      
    }
  }

  getActionRightsList() {
    this.useraddService.GetById(this.userid).subscribe(res => {
      let allUser: any = [];
      
      allUser = res.find(y => y.userid == this.userid);
      var data = JSON.parse(allUser.menumapped);
      //console.log(data);
      if (data != null && data != undefined && data.length != 0) {
        data = data.filter(e => e.menuid == 3);
        if (data != null && data != undefined && data.length != 0)
          this._actionRights = data[0].action;
        else
          this._actionRights = [];
      }

    })
  }
  
  LoadActionRights() {
    this.navmenuservice.postdata(this.userid).subscribe((res) => {
      if (res != undefined) {
        let allUser: any = [];
        this.list = res;
        
        /*allUser = res.find(y => y.userid == this.userid);
        var data = JSON.parse(allUser.menumapped);
        if (data != null && data != undefined && data.length != 0) {
          data = data.filter(e => e.menuid == this.sendMenuId);
          if (data != null && data != undefined && data.length != 0)
            this._actionRights = data[0].action;
          else
            this._actionRights = [];
        }*/
      }
    }, error => { this.toastr.error(error.error) });
  }

  //database loading user wise
  getUserMappedDatabase() {
    //user wise database loding
    this.UseraddService.GetById(this.userid).toPromise().then(res => {
      var data = []; let db: any = [];
      let dbuser: any = [];
      data = res;
      db = data.find(y => y.userid == this.userid);
      dbuser = data.find(y => y.userid == this.userid);
      //localStorage.setItem("userrole", db.userrole);
      this.localService.setJsonValue("userrole", db.userrole);
      this._usermappedDatabase = JSON.parse(dbuser.databasemapped).databasemapped;
      this.databaseService.getActive().toPromise().then(res => {
        var allData = [];
        allData = res;
        allData.forEach(item => {
          this._usermappedDatabase.forEach(a => {
            if (item.databaseid == a.databaseid) {
              //this.dataBases.push({
              //  databaseid: item.databaseid,
              //  database: item.database,
              //  iconclass: item.iconclass,
              //  databasedescription: item.databasedescription,
              //  databaseiconpath: item.databaseiconpath,
              //  status: item.status,
              //  createdby: item.createdby,
              //  createdon: item.createdon,
              //  modifiedby: item.modifiedby,
              //  modifiedon: item.modifiedon,
              //  active: item.active,
              //  databaseicon: item.databaseicon
              //});
              this.dataBases.push(item);
            }
          });
        });

      
        //sorting databases    
       // this.dataBases.sort((a, b) => (a.sequenceno > b.sequenceno) ? 1 : -1);
        this.dataBases.sort(function (a, b) { return a.sequenceno - b.sequenceno; });
      }, err => {
        this.toastr.error('error while getting the database data ')
      });


    }, error => {
      //console.log(error)
    });
  }

  getAllDataBases() {
    this.databaseService.getActive().subscribe(res => {
      this.dataBases = res
      this.dataBases.forEach(data => {
        // if (data.databaseiconpath != null) {
        this.databaseService.GetImage(data.databaseiconpath).subscribe(res => {

          let objectURL = 'data:image/jpeg;base64,' + res.image;
          data.databaseicon = this._sanitizer.bypassSecurityTrustUrl(objectURL)

        }, error => { });
        // }
      })

    }, err => {
      this.toastr.error('error while getting the database data ')
    }
    )
  }

  formConfig(database) {
    //alert(database);
    var data = database;
    if ((data != undefined) && (data.length != 0)) {
      this.database = data.databaseid + '*' + data.database;
      this.router.navigate(['/home/formconfig', { 'db': this.database }]);
    }
  }

  userConfig() {
      this.router.navigate(['/home/usermgt']);
  }

  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  mailConfig(database) {
    var data = database; var d = []; var menuId; var actionRights = [];
    //console.log(this.list);
    if ((this.list.length != 0 )&& (this.list != undefined)) {
      this.list.forEach(item => {
        if (item.menuid == 26) {
          d = item.children;
          if (d.length != 0) {
            d.forEach(a => {
              if (a.action == 'home/mailconfig') {
                menuId = a.menuid;
                actionRights = a.actionrights;
              }
            })
          }
        }
      })
    }
    if ((data != undefined) && (data.length != 0)) {
      this.database = data.databaseid + '*' + data.database;
      this.router.navigate(['/home/mailconfig'], { state: { menuid: menuId, action: actionRights, db: data.databaseid } });     
    }
  }

  formdashboardConfig(database) {
    //alert(database);
    var data = database;
    if ((data != undefined) && (data.length != 0)) {
      // this.database = data.databaseid + '*' + data.database;
      this.database = data.databaseid;
      //this.router.navigate(['/home/formdashboard', { 'db': this.database }]);
     // this.router.navigate(['/home/formdashboard', { 'db': this.database }]);
      this.router.navigate(['/home/formdashboard'], { queryParams: { 'db': this.database } });
    }
  }
}
